<template>
  <a
    class="
      link/enable:children
      link/focus
      layout/flex:column
    "
    :data-gtm="dataGtm"
    :href="link"
    >
    <picture
      class="picture"
      >
      <img
        class="picture/image"
        draggable="false"
        :src="imageUrl"
        loading="lazy"
        onerror="window.MoMA.onImageError(this, 1)"
        :alt="imageCaption"
      >
    </picture>
    <h3
      class="
        $layout/baseline:exact
        layout/padding:top:baseline
        typography
      "
      >
      <span
        class="
          balance-text
          "
          v-html="title"
        />
    </h3>
    <p
     class="
        $typography/scale:down
        $typography/weight:regular
        typography/truncate:4
        typography
        "
      >
      <span
        class="
          balance-text
        "
        v-html="subTitle"
      />
    </p>
    <p
      class="
        $color/alpha:54%
        $typography/scale:down
        $typography/weight:regular
        typography
      "
      v-html="detail"
    />
  </a>
</template>

<script>
import { MoMABalanceText } from 'sol';

  export default {
    props: {
      link: { type: String, required: true },
      imageUrl: { type: String, required: true },
      imageCaption: { type: String, required: true },
      title: { type: String, required: true },
      subTitle: { type: String, required: true },
      detail: { type: String, required: true },
      dataGtm: { type: String, required: true },
    },
    data: function() {
      return {
        balanceText: new MoMABalanceText(),
      };
    },

    mounted () {
      if (this.$el) {
        this.balanceText.balance(this.$el.getElementsByClassName('balance-text'));
      }
    },
  };
</script>
